








import {Auth, login} from "@/data/api/auth"
import {defineComponent, reactive} from "@vue/composition-api"
import router from "@/router"

export default defineComponent({
  setup() {
    const state = reactive({
      errorMsg: "",
    })
    const sso = {
      userId: router.currentRoute.query.user_id as string,
      sessionId: router.currentRoute.query.session_id as string,
    }
    login(sso as Auth)
    const q = router.currentRoute.query
    router.push({path: String(q.returnUrl || q.return_url || "/")})
    return {state}
  },
})
